import React from "react";
import { BsTelephoneFill } from "react-icons/bs";
import { AiOutlineMail } from "react-icons/ai";
const Footer = () => {
  return (
    <div className=" ">
      <div className="bg-[#DEC092] grid md:grid-cols-4 grid-cols-1 p-10 gap-4 md:gap-0">
        <div>
          <p className="text-sm ">
            No 117, Damazedi Road, Kamayut Township @Sharky’s Restaurant
          </p>
        </div>

        <div className="col-span-2 flex flex-col gap-4 md:items-center ">
          <div className="flex flex-col gap-3">
            <div className="flex flex-row items-center gap-3">
              <BsTelephoneFill />
              <p>09 250 368 687</p>
            </div>
            <div className="flex flex-row items-center gap-3">
              <AiOutlineMail />
              <p>watyeeoo1997@gmail.com</p>
            </div>
          </div>
        </div>
        <div className="md:justify-self-end">
          <button
            class="btn2 mt-12 border-black px-5 py-2 relative border e uppercase font-semibold tracking-wider leading-none overflow-hidden hover:text-white"
            type="button"
          >
            <span class="absolute inset-0 bg-black"></span>
            <span class="absolute inset-0 flex justify-center items-center font-bold">
              Go To Shop
            </span>
            Go To Shop
          </button>
        </div>
      </div>
      <p className="text-center bg-[#DEC092] pb-5">
        Copyright © {new Date().getFullYear()}- All rights reserved by{" "}
        <span className="font-bold">Whisky_House</span>
      </p>
    </div>
  );
};

export default Footer;
